export const initialState = {
  header: {
    changed: false
  },
  defaultDetail: { scoringDetailId: null, scoringDetailName: '' },
  details: [{ changed: false, isExpanded: false }]
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnHeaderPropertyChanged':
      return onHeaderPropertyChanged(state, action);
    case 'OnHeaderSave':
      return onHeaderSave(state, action);
    case 'OnDetailsPropertyChanged':
      return onDetailsPropertyChanged(state, action);
    case 'OnScoringCategoryAdd':
      return onScoringCategoryAdd(state, action);
    case 'OnDetailAdd':
      return onDetailAdd(state);
    case 'OnDetailSave':
      return onDetailSave(state, action);
    case 'OnDetailDelete':
      return onDetailDelete(state, action);
    case 'OnLookupPropertyChanged':
      return onLookupPropertyChanged(state, action);
    case 'OnDetailExpanded':
      return onDetailExpanded(state, action);

    default:
      return;
  }
}

function onInitState(state, action) {
  const { scoringCategory } = action;

  const hasDefaultDetail = scoringCategory.scoringCategoryDetails.some(x => x.defaultYN);

  return {
    ...state,
    header: {
      ...state.header,
      scoringId: scoringCategory.scoringId,
      orderNo: scoringCategory.orderNo,
      scoringCode: scoringCategory.scoringCode,
      scoringName: scoringCategory.scoringName,
      computed: scoringCategory.computed === null ? false : scoringCategory.computed,
      formula: scoringCategory.formula,
      inputTypeId: scoringCategory.inputTypeId,
      scale: scoringCategory.scale,
      sensitiveInfo: scoringCategory.sensitiveInfo === null ? false : scoringCategory.sensitiveInfo,
      changed: false
    },
    defaultDetail: {
      scoringDetailId:
        scoringCategory.scoringCategoryDetails !== null && hasDefaultDetail
          ? scoringCategory.scoringCategoryDetails.filter(x => x.defaultYN)[0].scoringDetailId
          : null,
      scoringDetailName:
        scoringCategory.scoringCategoryDetails !== null && hasDefaultDetail
          ? scoringCategory.scoringCategoryDetails.filter(x => x.defaultYN)[0].scoringDetailName
          : ''
    },
    details: scoringCategory.scoringCategoryDetails.map(item => {
      return { ...item, changed: false, isExpanded: false };
    })
  };
}

function onHeaderSave(state) {
  return {
    ...state,
    header: {
      ...state.header,
      changed: false
    }
  };
}

function onHeaderPropertyChanged(state, action) {
  const { propertyName, propertyValue } = action;
  return {
    ...state,
    header: {
      ...state.header,
      [propertyName]: propertyValue,
      changed: true
    }
  };
}

function onLookupPropertyChanged(state, action) {
  const { scoringDetailId, propertyId, scoringDetailName } = action;

  const scoringDetails = [...state.details];
  const index = scoringDetails.findIndex(x => x.scoringDetailId === scoringDetailId);
  const localDetails = scoringDetails.map((detail, idx) => {
    var item = { ...detail };
    item.defaultYN = idx === index ? true : false;
    return item;
  });

  return {
    ...state,
    header: { ...state.header, changed: true },
    defaultDetail: {
      ...state.defaultDetail,
      [propertyId]: scoringDetailId,
      scoringDetailName: scoringDetailName
    },
    details: localDetails
  };
}

function onDetailsPropertyChanged(state, action) {
  const { detailPropertyName, detailPropertyValue, index } = action;
  return {
    ...state,
    details: Object.assign([...state.details], {
      [index]: {
        ...state.details[index],
        [detailPropertyName]: detailPropertyValue,
        changed: true
      }
    })
  };
}

function onScoringCategoryAdd(state) {
  return {
    ...state,
    header: {
      ...state.header,
      scoringId: null,
      orderNo: null,
      scoringCode: '',
      scoringName: '',
      computed: false,
      formula: '',
      inputTypeId: null,
      scale: null,
      sensitiveInfo: false,
      changed: false
    },
    details: []
  };
}

function onDetailAdd(state) {
  const detail = {
    scoringDetailId: null,
    scoringId: state.header.scoringId,
    description: '',
    score: '',
    freeTxt: '',
    scoringDetailName: '',
    parentScoringDetailId: null,
    orderNo: null,
    code: '',
    defaultYN: false,
    minValue: null,
    maxValue: null,
    isExpanded: true,
    changed: false
  };
  const newDetails = Object.assign([...state.details]);
  newDetails.push({ ...detail, changed: true });

  return {
    ...state,
    details: newDetails
  };
}

function onDetailSave(state, action) {
  const { index } = action;
  return {
    ...state,
    details: Object.assign([...state.details], {
      [index]: {
        ...state.details[index],
        changed: false
      }
    })
  };
}

function onDetailDelete(state, action) {
  const { index } = action;
  const updatedDetails = Object.assign([...state.details]);
  updatedDetails.splice(index, 1);
  return {
    ...state,
    details: updatedDetails
  };
}

const onDetailExpanded = (state, action) => {
  const { index, isExpanded } = action;
  return {
    ...state,
    details: Object.assign([...state.details], {
      [index]: {
        ...state.details[index],
        isExpanded: isExpanded
      }
    })
  };
};
